import React, { FC } from 'react';
import TwDialog from '../../../components/TwDialog/TwDialog';
import { TwButton, TwButtonType } from '../../../components/TwButtons/TwButtons';
import { ReactComponent as Warning } from '../../../assets/icons/warning.svg';

interface TripWarningProps {
  isOpenWarning: boolean;
  closeWarning: () => void;
  handleClose: () => void;
}

const TripWarning: FC<TripWarningProps> = ({
  isOpenWarning,
  closeWarning,
  handleClose
}): JSX.Element => {
  return (
    <TwDialog open={isOpenWarning} title="Leave page?" onClickClose={closeWarning}>
      <div className="warning">
        <Warning />
        <p className="warning__message">
          You haven’t finished creating a trip.
          <br /> Do you want to leave without finishing?
        </p>
        <div className="warning__actions">
          <TwButton
            fullwidth={false}
            label="Close without saving"
            type={TwButtonType.secondary}
            action={handleClose}
          />
          <TwButton
            fullwidth={false}
            label="Continue creating load"
            type={TwButtonType.primary}
            action={closeWarning}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default TripWarning;
